import React from 'react';
import Breadcrumb from 'react-bootstrap/Breadcrumb';

import UIUtils from '../util/UIUtils';
import OasisUtils from './OasisUtils';
import SPUtilities from '../util/SPUtilities';
import UITableUtils from "../util/UITableUtils";
import RespUtils from '../util/RespUtils';
import Special from '../components/Special';
// import SSRecaptcha from '../base/SSRecaptcha';

class OasisPoolHeader extends React.Component {
  render() {
    return (
      <div>
        <Special />
        {this.getBreadCrumb()}
        <h5 style={{align: "center"}}><span><strong>{OasisUtils.entityNameFormatter(this.props.pool)}
            &nbsp;- {this.props.title}</strong></span>
          {UIUtils.renderPageActions(this, true, true)}</h5>
        {SPUtilities.getLastUpdatedGap(this.props.pool.lastUpdatedGap)}
        {UIUtils.getNotification(this.props.notification)}
      </div>
    );
  }

  getDesktopView() {
    if(this.props.desktopView == false) {
      return "";
    }

    return UITableUtils.renderSwitchView(this);
  }


  getBreadCrumb() {
    if (RespUtils.isTabletView()) {
      return (
        <Breadcrumb>
          <Breadcrumb.Item href="/">Validators</Breadcrumb.Item>
        </Breadcrumb>
      );
    } else {
      return "";
    }
  }

// <!--  <Breadcrumb.Item active>{this.props.pool.poolName} - Pool</Breadcrumb.Item> -->
  reload() {
    window.location.reload();
  }

}

export default OasisPoolHeader;



// WEBPACK FOOTER //
// ./src/oasis/OasisPoolHeader.js